import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Users, ArrowLeft } from 'lucide-react';
import type { Community } from '@/types';
import { useNavigate } from 'react-router-dom';

interface PendingRequestViewProps {
  community: Community;
}

export function PendingRequestView({ community }: PendingRequestViewProps) {
  const navigate = useNavigate();

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-4 bg-transparent relative overflow-hidden">
      <Card className="w-full max-w-md border-border/50 bg-background/60 backdrop-blur-xl shadow-2xl">
        <CardHeader className="text-center pb-2">
          <div className="mx-auto mb-4 w-20 h-20 rounded-2xl bg-secondary flex items-center justify-center overflow-hidden shadow-lg border border-border">
            {community.logo ? (
              <img
                src={community.logo}
                alt={community.name}
                className="w-full h-full object-cover"
              />
            ) : (
              <span className="text-3xl font-bold text-primary">{community.name.charAt(0)}</span>
            )}
          </div>
          <CardTitle className="text-2xl font-bold">{community.name}</CardTitle>
          <CardDescription className="flex items-center justify-center gap-2 mt-2">
            <Users className="w-4 h-4" />
            <span>Request pending</span>
          </CardDescription>
        </CardHeader>

        <CardContent className="text-center pt-4 space-y-3">
          <p className="text-muted-foreground text-sm">
            Your request to join this community has been sent and is awaiting approval from the
            admins. We will notify you when your request is approved.
          </p>
        </CardContent>

        <CardFooter className="flex flex-col gap-3 pb-8 px-8">
          <Button
            className="w-full h-12 text-lg font-semibold bg-primary hover:bg-primary/90 shadow-lg"
            onClick={() => navigate('/dashboard')}
          >
            <ArrowLeft className="mr-2 w-5 h-5" /> Back to communities
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
